import { languages } from '../config/languages';
import { readCookie, writeCookie } from './cookies';

// The site language is a setting, like the accessibility settings: chosen in
// the menu (LanguageSwitcher) and kept in a first-party preference cookie.
// Browser Back / Forward only move between pages; they show the page in the
// chosen language and never change the setting (see LanguageOverHistory).
const COOKIE_KEY = 'ukwa-lang';

const isLanguage = (code) => Object.prototype.hasOwnProperty.call(languages, code);

export function getPreferredLanguage() {
  const code = readCookie(COOKIE_KEY);
  return isLanguage(code) ? code : null;
}

export function setPreferredLanguage(code) {
  if (isLanguage(code)) writeCookie(COOKIE_KEY, code);
}

// The locale of a path: its first segment when that is a known language.
export function languageOfPath(pathname) {
  const first = pathname.split('/')[1];
  return isLanguage(first) ? first : null;
}

// Where the same page lives in another language: every page carries its
// locale as the first path segment, so swap that one segment and keep the
// rest (/en/ukwa/collection/105 → /cy/ukwa/collection/105). Without a locale
// segment (a legacy unprefixed URL caught mid-redirect), prefix the target.
export function pathIn(targetLangCode, location) {
  const segments = location.pathname.split('/'); // ['', 'en', 'ukwa', ...]
  if (isLanguage(segments[1])) {
    segments[1] = targetLangCode;
    return (segments.join('/') || '/') + location.search;
  }
  return languages[targetLangCode].urlPrefix + location.pathname + location.search;
}
